import i18n from "../../../../i18n"
import OpeningTimesDays from "./OpeningTimesDays"

const OpeningTimes = ({openingHours}) => {
    if(!openingHours) return null
    return <div className=' w-100 d-flex flex-column col-12 col-lg-8 bg-light mt-2 p-2'>  
            <h5 className='mt-2 text-center'>{i18n.t('Openingstijden')}</h5>
            <table className='table '>
                <thead> 
                    <tr>
                        <th>{i18n.t('Dag')}</th>
                        <th>{i18n.t('Openingstijden')}</th>
                    </tr>
                </thead>
                <tbody>
                    <OpeningTimesDays dayName={i18n.t('Maandag')} day={'monday'} openingHours={openingHours} />
                    <OpeningTimesDays dayName={i18n.t('Dinsdag')} day={'tuesday'} openingHours={openingHours} />
                    <OpeningTimesDays dayName={i18n.t('Woensdag')} day={'wednesday'} openingHours={openingHours} />
                    <OpeningTimesDays dayName={i18n.t('Donderdag')} day={'thursday'} openingHours={openingHours} />
                    <OpeningTimesDays dayName={i18n.t('Vrijdag')} day={'friday'} openingHours={openingHours} />
                    <OpeningTimesDays dayName={i18n.t('Zaterdag')} day={'saturday'} openingHours={openingHours} />
                    <OpeningTimesDays dayName={i18n.t('Zondag')} day={'sunday'} openingHours={openingHours} />
                </tbody>
            </table>
        </div>
}

export default OpeningTimes